import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import store from './state/store'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
);

const appWidth = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-max-width', `60em`);
};

const appHeight = () => {
  const doc = document.documentElement;
  const safeAreaInsetBottom = getComputedStyle(doc).getPropertyValue("--sab")
    .replace('px', '');
  doc.style.setProperty('--app-height', `calc(${window.innerHeight}px - ${safeAreaInsetBottom || 0}px)`);
};

window.addEventListener('orientationchange', appHeight);
window.addEventListener('resize', appHeight);
window.addEventListener('fullscreenchange', appHeight);
window.addEventListener('load', appHeight);
window.addEventListener('DOMContentLoaded', appHeight);
window.addEventListener('visibilitychange', appHeight);

appHeight();
appWidth();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
